import { jsx, jsxs } from "react/jsx-runtime";
import { DialogFooter, wrapDialog } from "@teselagen/ui";
import { Button, Callout, Card } from "@blueprintjs/core";
import { hideDialog } from "../GlobalDialogUtils";
import SimpleCircularOrLinearView from "../SimpleCircularOrLinearView";
import React, { useState } from "react";
import { tidyUpSequenceData } from "@teselagen/sequence-utils";
export const MultipleSeqsDetectedOnImportDialog = wrapDialog({
  title: "Multiple Sequences Detected"
  // style: { height: 600, width: 800 }
})(({ results, finishDisplayingSeq }) => {
  const [_selectedSeqData, setSelectedSeqData] = useState(
    results[0].parsedSequence
  );
  const selectedSeqData = tidyUpSequenceData(_selectedSeqData);
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs("div", { className: "bp3-dialog-body", children: [
      /* @__PURE__ */ jsx(Callout, { intent: "primary", children: "Multiple sequences were detected in the input file. Please choose one to continue" }),
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsxs("div", { style: { display: "flex" }, children: [
        /* @__PURE__ */ jsx("div", { style: { maxHeight: 300, overflowY: "auto" }, children: results.map((res, i) => {
          const { parsedSequence } = res;
          if (!parsedSequence) return null;
          const { name } = parsedSequence;
          return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
            Button,
            {
              active: parsedSequence === selectedSeqData,
              onClick: () => {
                setSelectedSeqData(parsedSequence);
              },
              minimal: true,
              children: name
            }
          ) }, i);
        }) }),
        "\xA0",
        /* @__PURE__ */ jsx(Card, { elevation: 1, children: /* @__PURE__ */ jsx(
          SimpleCircularOrLinearView,
          {
            sequenceData: selectedSeqData || { sequence: "" },
            editorName: "previewEditor",
            height: null,
            isProtein: selectedSeqData && selectedSeqData.isProtein,
            annotationLabelVisibility: {
              features: true,
              parts: true,
              cutsites: false,
              primers: true
            }
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ jsx(
      DialogFooter,
      {
        text: "Select",
        onClick: () => {
          finishDisplayingSeq(selectedSeqData);
          hideDialog();
        }
      }
    )
  ] });
});
